export default "__VITE_ASSET__jQHFFx1A__"